import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 40
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
    text :{
        fontSize: 10,
    }
  });


  const BillTo = ({header, title}) => (
      
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}/>
        <Text  style={styles.fontSize}>{header.CardName}</Text>
        <Text  style={styles.fontSize}>{header.CardCode}</Text>
        <Text  style={{fontWeight: 'bold'}}>{`Número de ${title} : ${header.DocNum} `}</Text>
    </View>
  );
  
  export default BillTo